var map = {
	"./background/bio.ru.png": 1690,
	"./background/chemestry.ru.png": 4986,
	"./background/cno.ru.png": 3869,
	"./background/ffk.ru.png": 9991,
	"./background/filologia.ru.png": 9387,
	"./background/geo.ru.png": 5068,
	"./background/history.ru.png": 6654,
	"./background/law.ru.png": 409,
	"./background/math.ru.png": 5554,
	"./background/pedfak.ru.png": 8084,
	"./background/physics.ru.png": 6737,
	"./background/pshyhology.ru.png": 5200,
	"./background/rgf.ru.png": 143,
	"./background/tversu.ru.png": 153,
	"./svg/add.svg": 1085,
	"./svg/add_circle.svg": 374,
	"./svg/approved.svg": 1811,
	"./svg/arrow-up-left.svg": 1060,
	"./svg/background/bio.svg": 4508,
	"./svg/background/chemestry.svg": 9865,
	"./svg/background/cno.svg": 3980,
	"./svg/background/ffk.svg": 2831,
	"./svg/background/filologia.svg": 8791,
	"./svg/background/geo.svg": 485,
	"./svg/background/history.svg": 1508,
	"./svg/background/law.svg": 8758,
	"./svg/background/math.svg": 6468,
	"./svg/background/pedfak.svg": 5018,
	"./svg/background/physics.svg": 1411,
	"./svg/background/pshyhology.svg": 7072,
	"./svg/background/rgf.svg": 612,
	"./svg/background/tvsu.svg": 2553,
	"./svg/box.svg": 7404,
	"./svg/box_youtube.svg": 5988,
	"./svg/delete.svg": 4393,
	"./svg/delete_circle.svg": 7511,
	"./svg/denied.svg": 8076,
	"./svg/edit.svg": 6839,
	"./svg/external_link.svg": 2145,
	"./svg/flags/en.svg": 7287,
	"./svg/flags/fr.svg": 7046,
	"./svg/flags/ru.svg": 3918,
	"./svg/flags/zh-CN.svg": 8137,
	"./svg/logo/en.svg": 2316,
	"./svg/logo/fr.svg": 7410,
	"./svg/logo/logo.svg": 2066,
	"./svg/logo/ru.svg": 5951,
	"./svg/logo/zh-CN.svg": 1808,
	"./svg/low_visible.svg": 2283,
	"./svg/money.svg": 4227,
	"./svg/move.svg": 1212,
	"./svg/move_right.svg": 8569,
	"./svg/people.svg": 672,
	"./svg/price.svg": 2708,
	"./svg/restore.svg": 7724,
	"./svg/ruble.svg": 5102,
	"./svg/social_networks/classmates.svg": 3375,
	"./svg/social_networks/dzen.svg": 1528,
	"./svg/social_networks/facebook.svg": 8545,
	"./svg/social_networks/instagram.svg": 2343,
	"./svg/social_networks/max_messenger.svg": 3774,
	"./svg/social_networks/rutube.svg": 8656,
	"./svg/social_networks/telegram.svg": 2063,
	"./svg/social_networks/twitter.svg": 5100,
	"./svg/social_networks/vk.svg": 9665,
	"./svg/social_networks/whatsapp.svg": 1175,
	"./svg/social_networks/youtube.svg": 7050,
	"./svg/student.svg": 4026,
	"./svg/student_hat.svg": 2791,
	"./svg/table_pencil.svg": 5682,
	"./svg/user.svg": 887,
	"./web/android-chrome-192x192.png": 6812,
	"./web/android-chrome-512x512.png": 3229,
	"./web/apple-touch-icon.png": 1830,
	"./web/content/employees-no_photo_index.png": 3417,
	"./web/content/employees-no_photo_show.png": 1281,
	"./web/favicon-16x16.png": 3602,
	"./web/favicon-32x32.png": 3522,
	"./web/favicon.ico": 3941,
	"./web/files_icons/doc.svg": 4628,
	"./web/files_icons/exe.svg": 7178,
	"./web/files_icons/folder.png": 9306,
	"./web/files_icons/pdf.svg": 8563,
	"./web/files_icons/ppt.svg": 686,
	"./web/files_icons/txt .svg": 2863,
	"./web/files_icons/unknown.svg": 1717,
	"./web/files_icons/xls.png": 7312,
	"./web/files_icons/xls.svg": 4066,
	"./web/footer_bg.jpg": 4318,
	"./web/logo_footer2.png": 8217,
	"./web/mstile-150x150.png": 8518,
	"./web/news__bg.jpg": 4563,
	"./web/no_used/footer_bg.jpg": 1902,
	"./web/no_used/news__bg.png": 1759,
	"./web/no_used/ul_li.png": 8823,
	"./web/priem_card_footer.png": 8885,
	"./web/priem_header.png": 7959,
	"./web/priem_heart.png": 6214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7325;